import { Sg_Social } from '@7graus/sg-resources-legacy';
import { loadScript } from './utils';
import { EnvironmentType, getEnvironmentType } from './utils/environment';
import 'regenerator-runtime/runtime';
import './events/clicks-tracker';
import './events/funnel-tracker';
import './events/engagement-tracker';
import { store, slices, selectors } from "./user-area/redux/store";
import { showLoginModal } from "./user-area/utils/loginModal";
import { setShouldShowRegisterModal } from "./user-area/utils/registerModal";
import { showToast } from './components/tm-toast';
import { isLumeRoute } from './common/lume-route';
import './utils/ad-params.ts';
import './utils/ambassador-ref.ts';
import { callStartTrialAPI } from './user-area/utils/trial';
import { initLumeEntryLinks } from './utils/lume-entry';
import { hasPaymentConfirmingFlag } from './utils/payment-confirming-flag';

window.SGSocial = Sg_Social || {};
window.showLoginModal = showLoginModal;

// Simuladão has its own post-login inscription form (tm-simuladao-register-modal),
// so suppress the generic "Quase pronto!" profile modal on that page.
if (document.querySelector('.sm-page')) {
  setShouldShowRegisterModal(false);
}

// Simuladão solving engine — load when there's a startable prova, the demo, or a
// post-close gabarito review to open (the Resultados page uses only the last).
if (document.querySelector('[data-sim-start]') || document.querySelector('[data-sim-demo]') || document.querySelector('[data-sim-review]')) {
  import('./simuladao/index').catch((error) => {
    console.error('Failed to load simuladao module:', error);
  });
}

window.addEventListener('articlePageLoaded', (e) => {
  const context = e.detail.context || document;
  loadArticleEssentials(context);
})

window.addEventListener('loadCommunityBanner', (e) => {
    const context = e && e.detail && e.detail.context;
    loadCommunityBanner(context || document);
});


import('./user-area/index').then(() => {
  loadScript('https://accounts.google.com/gsi/client?hl=pt-BR', { async: true, defer: true });
}).catch((error) => {
  console.error('Failed to load user-area module:', error);
});

import('bootstrap').catch((error) => {
  console.error('Failed to load bootstrap module:', error);
});


if (document.querySelector('#article')) {
  loadArticleEssentials(document);
}

// Outside loadArticleEssentials: the mobile bar and its sheet live next to the
// header, so they exist on article layouts that never render #article.
if (document.querySelector('[data-topic-ladder]')) {
  import('./components/topic-ladder.ts')
  .then((module) => module.default(document))
  .catch((error) => {
    console.error('Failed to load topic-ladder:', error);
  });
}

initLumeEntryLinks();

// Fixed-position and rendered before the footer, so it is not inside #article
// and loadArticleEssentials never sees it.
if (document.querySelector('[data-lume-balloon]')) {
  import('./components/lume-balloon.ts')
  .then((module) => module.default(document))
  .catch((error) => {
    console.error('Failed to load lume-balloon:', error);
  });
}

if (document.querySelector('checkout-form-controller')) {
    import('./checkout/checkout-form-controller.ts').catch((error) => {
      console.error('Failed to load checkout-form-controller:', error);
    });
}

if (window.location.pathname.startsWith('/checkout')) {
    import('./utils/checkout-return').then((module) => module.captureCheckoutReturn()).catch((error) => {
      console.error('Failed to load checkout-return:', error);
    });
}

const checkoutThanks = document.querySelector('.co-thanks');
if (checkoutThanks) {
    import('./checkout/checkout-thanks.ts').then((module) => module.default(checkoutThanks)).catch((error) => {
      console.error('Failed to load checkout-thanks:', error);
    });
}

if (window.tmPlusPlans) {
    import('./tmplus/plan-select-tracker.ts').then((module) => module.default()).catch((error) => {
      console.error('Failed to load tmplus plan-select-tracker:', error);
    });
}

if (document.querySelector('tm-chat-bot')) {
  import('./chat-bot/index').catch((error) => {
    console.error('Failed to load chat-bot module:', error);
  });
}

if (document.querySelector('tm-tpc-corrector')) {
  import('./tpc/index').catch((error) => {
    console.error('Failed to load tpc module:', error);
  });
}

if (document.querySelector('tm-corrector')) {
  import('./corrector/index').catch((error) => {
    console.error('Failed to load corrector module:', error);
  });
}

if (document.querySelector('tm-assistant-bot')) {
  import('./assistant-bot/index').catch((error) => {
    console.error('Failed to load assistant-bot module:', error);
  });
}

if (document.querySelector('#navBarContainer')) {
  import('./components/header').then((module) => module.default());
}

if (document.querySelector('tm-navbar-autocomplete')) {
  import('./components/navbar-autocomplete.ts').catch((error) => {
    console.error('Failed to load navbar-autocomplete:', error);
  });
}

if(document.querySelector('sticky-header-menu-button')) {
  import('./components/sticky-header-menu-button.ts').catch((error) => {
    console.error('Failed to load sticky-header-menu-button:', error);
  });
}

if(document.querySelector('#tabela-periodica')) {
  import('./components/tabela-periodica.js')
  .then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load tabela-periodica:', error);
  });
}

if(document.querySelector('#headerMapaBrasil')) {
  import('./components/mapa-brasil.js')
  .then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load mapa-brasil:', error);
  });
}

if(document.querySelector('.simulado-wrapper')) {
  import('./components/simulado.js')
  .then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load simulado:', error);
  });
}

if(document.querySelector('interactive-learning')) {
  import('./interactive-learning/index')
  .catch((error) => {
    console.error('Failed to load interactive-learning:', error);
  });
}

if(document.querySelector('tm-tooltip')) {
  import('./exercises/components/listing-tooltips')
  .catch((error) => {
    console.error('Failed to load listing-tooltips:', error);
  });
}

if(document.querySelector('tm-exercises')) {
  import('./exercises/index')
  .catch((error) => {
    console.error('Failed to load exercises:', error);
  });
} else {
  if (document.querySelector('tm-exercises-progress-bar')) {
    import('./exercises/components/progress-bar')
    .catch((error) => {
      console.error('Failed to load progress-bar:', error);
    });
  }
}

if (document.querySelector('.sg-oembed')) {
  import( 
    "@7graus/sg-resources-legacy/src/sg_oembed/sg_oembed"
  ).then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load sg_oembed:', error);
  });
}

if (document.querySelector('monthly-calendar')) {
  import('./components/monthly-calendar')
  .catch((error) => {
    console.error('Failed to load monthly-calendar:', error);
  });
}

if (document.querySelector('achievement-item-controller')) {
  import('./achievements/components/achievement-item-controller')
  .catch((error) => {
    console.error('Failed to load achievement-item-controller:', error);
  });
}

if (document.querySelector('page-view-award-controller')) {
  import('./achievements/components/page-view-award-controller')
  .catch((error) => {
    console.error('Failed to load page-view-award-controller:', error);
  });
}

if(document.querySelector('.box-social')) {
  SGSocial.init();
}

if(document.querySelector('.testimonials-widget') || document.querySelector('.testimonials-carousel')) {
  import('./components/hero-carousel').then(function (module) {
    module.default();
  }).catch((error) => {
    console.error('Failed to load hero-carousel:', error);
  });
}

if(document.querySelector('.testimonials-carousel')) {
  import('./components/testimonials-carousel').then(function (module) {
    module.default();
  }).catch((error) => {
    console.error('Failed to load testimonials-carousel:', error);
  });
}

if (document.querySelector('sticky-widget-controller')) {
  import('./components/sticky-widget-controller').then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load sticky-widget-controller:', error);
  });
}

if(document.querySelector('exercises-search-autocomplete')) {
  import('./exercises/components/search-autocomplete.ts').then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load search-autocomplete:', error);
  });
}

if(document.querySelector('#pix-transaction') ) {
  import('./components/pix-payment-confirmation').then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load pix-payment-confirmation:', error);
  });
}

if(document.querySelector('#stripe-transaction')) {
  import('./components/stripe-payment-confirmation').then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load stripe-payment-confirmation:', error);
  });
}

if (hasPaymentConfirmingFlag()) {
  document.querySelectorAll('.btn-header-tmplus').forEach((link) => link.setAttribute('href', '/user/gerir-assinatura/'));
}

if(document.querySelector('[data-payment-confirming]')) {
  import('./components/payment-confirming-poller').then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load payment-confirming-poller:', error);
  });
}

if(document.querySelector('searchable-select')) {
  import('./components/searchable-select')
  .catch((error) => {
    console.error('Failed to load searchable-select:', error);
  });
}

if (document.querySelector('week-selector')) {
  import('./enem/components/week-selector.ts')
  .catch((error) => {
    console.error('Failed to load week-selector:', error);
  });
}
if (document.querySelector('week-navigation')) {
  import('./enem/components/week-navigation.ts')
  .catch((error) => {
    console.error('Failed to load week-navigation:', error);
  });
}
if (document.querySelector('study-plan-grid')) {
  import('./enem/components/study-plan-grid')
  .catch((error) => {
    console.error('Failed to load study-plan-grid:', error);
  });
}

if (document.cookie.includes('enem_tm_toast')) {
  showToast({
    title: '<b>Toda Matéria+ ativado!</b>',
    message: 'Acesso total liberado por 7 dias.',
    cookieName: 'enem_tm_toast',
    removeCookieOnShow: true,
    duration: 5000
  });
}

if (document.querySelector('tm-article-content-format')) {
  import('./article-content-format/index').then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load article-content-format:', error);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  if (isLumeRoute()) {
    return;
  }
  const state = store.getState();
  const authState = state[slices.auth.name];
  const user = selectors.auth.getUser(authState);
  if (!user?.id) {
    return;
  }
  const visitNumber = Number(localStorage.getItem(`tm_toast_whatsapp_visit_number_${user.id}`));
  localStorage.setItem(`tm_toast_whatsapp_visit_number_${user.id}`, visitNumber + 1);

  if(!localStorage.getItem(`tm_toast_whatsapp_${user.id}`) && visitNumber == 2) {
    showToast({
      title: '<b>ENEM:</b> Conteúdo gratuito e direto ao ponto.',
      message: '<a href="https://tiddly.xyz/xudXD" target="_blank"><b>Vem pro nosso canal no WhatsApp.</b></a>',
      icon: 'icon-whatsapp',
      showProgressBar: false,
      showCloseButton: true,
      closeMode: 'manual',
      customCssClass: 'tm-toast--whatsapp',
      width: 'auto',
      iconPosition: 'block'
    });
    localStorage.setItem(`tm_toast_whatsapp_${user.id}`, 'true');
  }
});

if (document.querySelector('.enem-paywall-modal')) {
  const observer = new MutationObserver((mutations, obs) => {
    const state = store.getState();
    const authState = state[slices.auth.name];
    const user = selectors.auth.getUser(authState);

    const el = document.querySelector('.enem-paywall-google-section');
    if (el) {
      if (!user || !user.id) {
        if (document.querySelector('.enem-simulado')) {
          if (localStorage.getItem('tm_enem_simulado_paywall_shown')) {
            document.getElementsByClassName('enem-container')[0].classList.remove('enem-container--overlay');
            document.body.style.setProperty('overflow', 'auto', 'important');
            return;
          }
          document.getElementsByClassName('enem-container')[0].classList.add('enem-container--overlay');

          localStorage.setItem(`tm_enem_simulado_paywall_shown`, true);
        }
        try {
          // Define if the register modal should not be shown for this context
          setShouldShowRegisterModal(false);

          const loginHeader = el.dataset.loginHeader || 'Este conteúdo é exclusivo do <span>Toda Matéria+</span>';
          const loginSubHeader = el.dataset.loginSubheader || '';
          showLoginModal(loginHeader,()=>{
              window.location.reload();
          }, loginSubHeader)
        } catch (error) {
          window.location.href = `/login/`;
        }
      }

      obs.disconnect();
    }
    if (user && !user.isPremium) {
      const modalElement = document.querySelector('#tmplus-login-modal');
      if (modalElement) {
        modalElement.classList.add('tmplus-login-modal--show');
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

if (document.querySelector('study-plan-modal')) {
  import('./enem/components/study-plan-modal')
  .catch((error) => {
    console.error('Failed to load study-plan-modal:', error);
  });
}
if (document.querySelector('enem-discipline')) {
  import( './enem/components/enem-discipline')
  .catch((error) => {
    console.error('Failed to load enem-discipline:', error);
  });
}
if (document.querySelector('study-progress-widget')) {
  import('./enem/components/study-progress-widget')
  .catch((error) => {
    console.error('Failed to load study-progress-widget:', error);
  });
}

loadCommunityBanner(document);

const bhof = `${getEnvironmentType() !== EnvironmentType.DEVELOPMENT ? 'https://7gra.us' : '//resources.test'}/bhof.js`;
loadScript(bhof, { async: true });

function loadArticleEssentials(context) {
  if (context.querySelector('favorite-button')) {
    import('./user-area/components/favorite-button.ts')
    .catch((error) => {
      console.error('Failed to load favorite-button:', error);
    });
  }

  if (context.querySelector('tm-print-button')) {
    import('./print/print-button.ts')
    .catch((error) => {
      console.error('Failed to load tm-print-button:', error);
    });
  }

  if(context.querySelector('#article table')) {
    import('./components/article-table.js')
    .then((module) => module.default(context))
    .catch((error) => {
      console.error('Failed to load article-table:', error);
    });
  }
  
  if(context.querySelector('#roman-numerals-widget')) {
    import('./components/roman-numerals.js')
    .then((module) => module.default(context))
    .catch((error) => {
      console.error('Failed to load roman-numerals:', error);
    });
  }

  if(context.querySelector('.multiple-choice')) {
    console.log('multiple-choice');
    import('./components/multiple-choice.js')
    .then((module) => module.default(context))
    .catch((error) => {
      console.error('Failed to load multiple-choice:', error);
    });
  }

  if (context.querySelector('[data-suggested-questions]')) {
    import('./components/suggested-questions.ts')
    .then((module) => module.default(context))
    .catch((error) => {
      console.error('Failed to load suggested-questions:', error);
    });
  }

  if (context.querySelector('.answer-buttons')) {
    import('./components/answer-button.js')
    .then((module) => module.default(context))
    .catch((error) => {
      console.error('Failed to load answer-button:', error);
    });
  }

  if(context.querySelector("#cite-collapse")) {
    context.querySelector("#cite-collapse").addEventListener('click', () => {
      import('./components/post-cite.js')
      .then((module) => module.default(context))
      .catch((error) => {
        console.error('Failed to load post-cite:', error);
      });
    });
  }

  if(context.querySelector('#article[data-is-gabarito-ads]')) {
    import('./components/gabarito-ads/index.ts')
    .then((module) => module.default())
    .catch((error) => {
      console.error('Failed to load gabarito-ads:', error);
    });
  }

  if ('loading' in HTMLImageElement.prototype) {
    const allLazyloadImages = context.querySelectorAll("img[loading]");
    allLazyloadImages.forEach(img => {
        img.src = img.dataset.src;
    });
  }
};

function loadCommunityBanner(context) {
    if (!context) context = document;
    if(context.querySelector('community-banner')) {
        import('./components/community-banner.js')
        .then((module) => module.default())
        .catch((error) => {
          console.error('Failed to load community-banner:', error);
        });
    }
}


if(document.querySelector('simulador-sisu')) {
  console.log('simulador-sisu');
  import('./components/simulador-sisu.js')
  .catch((error) => {
    console.error('Failed to load simulador-sisu:', error);
  });
}

if(document.querySelector('.section-socialproof--circular')) {
  import('./utils/socialproof-scroll-animation.js')
  .then((module) => module.initSocialproofScrollAnimation())
  .catch((error) => {
    console.error('Failed to load socialproof-scroll-animation:', error);
  });
}

if(document.querySelector('.tools-section--content-container')) {
  console.log('setup-tools-section');
  import('./utils/setup-tools-section.js')
  .then((module) => module.default())
  .catch((error) => {
    console.error('Failed to load setup-tools-section:', error);
  });
}

